import { render, staticRenderFns } from "./DashboardDetailCSI.vue?vue&type=template&id=e90e3780&"
import script from "./DashboardDetailCSI.vue?vue&type=script&lang=js&"
export * from "./DashboardDetailCSI.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDetailCSI.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports